import { statsTheme } from '.'
import { StatsThemeKey, StatsThemeModel } from '../../types'

export const getStatsTheme = (key: StatsThemeKey) => statsTheme[key]

export const getStatsThemeModel = (theme?: StatsThemeKey): StatsThemeModel => {
  switch (theme) {
    case 'spooky':
      return 'spooky'
    case 'holiday':
      return 'holiday'
    default:
      return 'core'
  }
}
